"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideEditNavBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var GuideEditNavBar = function (_a) {
    var _b = _a.shouldViewDraft, shouldViewDraft = _b === void 0 ? false : _b, backText = _a.backText, backLink = _a.backLink, viewLink = _a.viewLink, historyLink = _a.historyLink, translateText = _a.translateText, translateLink = _a.translateLink, toggleGuideStepEditV2Control = _a.toggleGuideStepEditV2Control, guideStepEditorV2FeedbackFormLink = _a.guideStepEditorV2FeedbackFormLink, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? LinkWithoutUnderline : _c, _js = _a._js;
    var viewText = shouldViewDraft ? _js('View Draft') : _js('View');
    var optionsText = _js('Options');
    var historyText = _js('History');
    var navBarHeight = '50px';
    var iconSize = 'lg';
    var marginBetweenIconAndText = '12px';
    var fontSize = '14px';
    var buttonStyle = {
        colorScheme: 'blackAlpha',
        color: 'blueGray.700',
        variant: 'ghost',
        h: navBarHeight,
    };
    function openGuideStepEditorV2FeedbackForm() {
        if (guideStepEditorV2FeedbackFormLink) {
            window.open(guideStepEditorV2FeedbackFormLink, '_blank');
        }
    }
    return (React.createElement(react_1.Box, { bg: "gray.200", w: "100%", h: navBarHeight, className: "page-navigation-container", pl: 3, pr: 3 },
        React.createElement(react_1.Flex, { direction: "row", justify: "space-between", align: "center" },
            backLink && (React.createElement(LinkComponent, { href: backLink },
                React.createElement(react_1.Button, __assign({}, buttonStyle, { id: "back-nav-link" }),
                    React.createElement(react_1.Flex, { align: "center" },
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faArrowLeft, size: iconSize }),
                        React.createElement(react_1.Text, { fontSize: fontSize, marginLeft: marginBetweenIconAndText }, backText))))),
            React.createElement(react_1.Flex, { align: "center", marginLeft: "auto" },
                viewLink && (React.createElement(LinkComponent, { href: viewLink },
                    React.createElement(react_1.Button, __assign({}, buttonStyle, { id: "view-nav-link" }),
                        React.createElement(react_1.Flex, { align: "center" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faFileLines, size: iconSize }),
                            React.createElement(react_1.Text, { fontSize: fontSize, ml: marginBetweenIconAndText }, viewText))))),
                (translateLink || historyLink || toggleGuideStepEditV2Control) && (React.createElement(react_1.Menu, { offset: [0, 7] },
                    React.createElement(react_1.MenuButton, __assign({ as: react_1.Button }, buttonStyle, { className: "js-content-dropdown-toggle content-dropdown-toggle" }),
                        React.createElement(react_1.Flex, { align: "center" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faEllipsis, size: iconSize }),
                            React.createElement(react_1.Text, { fontSize: fontSize, ml: marginBetweenIconAndText }, optionsText))),
                    React.createElement(react_1.MenuList, { className: "content-dropdown-list", boxShadow: "md" },
                        toggleGuideStepEditV2Control === 'enable' && (React.createElement(LinkComponent, { href: "/Guide/v2-editor/enable" },
                            React.createElement(react_1.MenuItem, { px: 4, py: 3, alignItems: "center", "data-feature-id": "guide-step-edit-v2-enable" },
                                React.createElement(react_1.Badge, { colorScheme: "green" }, _js('New')),
                                React.createElement(react_1.Text, { fontSize: fontSize, marginLeft: marginBetweenIconAndText }, _js('Preview new Authoring Experience'))))),
                        toggleGuideStepEditV2Control === 'disable' && (React.createElement(LinkComponent, { href: "/Guide/v2-editor/disable", onClick: openGuideStepEditorV2FeedbackForm },
                            React.createElement(react_1.MenuItem, { px: 4, py: 3, "data-feature-id": "guide-step-edit-v2-disable" },
                                React.createElement(react_1.Flex, { align: "center" },
                                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faRotateLeft, size: iconSize }),
                                    React.createElement(react_1.Text, { fontSize: fontSize, marginLeft: marginBetweenIconAndText }, _js('Disable new Authoring Experience')))))),
                        translateLink && (React.createElement(LinkComponent, { href: translateLink },
                            React.createElement(react_1.MenuItem, __assign({ px: 4, py: 3 }, buttonStyle, { id: "translate-nav-link", "data-feature-id": "guide-edit-nav-translate" }),
                                React.createElement(react_1.Flex, { align: "center" },
                                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faGlobe, size: iconSize }),
                                    React.createElement(react_1.Text, { fontSize: fontSize, marginLeft: marginBetweenIconAndText }, translateText))))),
                        historyLink && (React.createElement(LinkComponent, { href: historyLink },
                            React.createElement(react_1.MenuItem, { px: 4, py: 3 },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faHistory, size: iconSize }),
                                React.createElement(react_1.Text, { fontSize: fontSize, marginLeft: marginBetweenIconAndText }, historyText)))))))))));
};
exports.GuideEditNavBar = GuideEditNavBar;
function LinkWithoutUnderline(props) {
    return React.createElement(react_1.Link, __assign({}, props, { _hover: { textDecoration: 'none' } }));
}
